import { i18n, DEFAULT_APP_LOCALE } from "@/i18n";
const INTL_LOCALES = {
    es: "es-ES",
    en: "en-US",
};
export function resolvePdfLocale(locale) {
    return locale === "en" ? "en" : DEFAULT_APP_LOCALE;
}
export function toIntlLocale(locale) {
    return INTL_LOCALES[resolvePdfLocale(locale)];
}
export function translatePdf(locale, key, named) {
    return i18n.global.t(key, named ?? {}, {
        locale: resolvePdfLocale(locale),
    });
}
